export const PROJECT_PERIOD_COLORS = [
    "#dbeafe",
    "#dcfce7",
    "#fef3c7",
    "#ffe4e6",
    "#ccfbf1",
    "#ede9fe",
    "#fae8ff",
    "#e0f2fe",
    "#ecfccb",
    "#ffedd5",
] as const;
